/**
 *  Populate a template - returns a rendered template that can be inserted into the dom.
 *
 * @param id String - a template id
 * @param datamap Object Literal - {key: [selector, attribute]} map data to a selector and attribute to populate
 * @param data Object Literal - {key: data} or { key: [{search}, {replace}]} the data to insert into the template
 * @returns fragment DocumentFragment - the rendered template
 */

module.exports = {
  populate: populate,
  gettemplates: gettemplates
}

var supported = 'content' in document.createElement('template');
var templates = {};

// Polyfill <template>
// Clone template elements into a DocumentFragment
// and store in a hash, then remove the original node
// this will keep the templates mostly inert.
// CAVEAT: scripts will run

function gettemplates(html) {
  if (!supported) {
    var nodes = html.querySelectorAll('template');
    var i = -1;
    var node;
    for (; node = nodes[++i];) {
      if (!templates[node.id]) {
        var fragment = document.createDocumentFragment();
        var children = node.children;
        var iterator = -1;
        var child;
        for (; child = children[++iterator];) {
          fragment.appendChild(child.cloneNode(true));
        }

        templates[node.id] = fragment;
      }

      node.parentNode.removeChild(node);
    }
  }

  return html;
}

var clone = function (id) {
  return supported ? document.getElementById(id).content : templates[id]
 };

function populate(id, datamap, data) {
  var fragment = id.nodeName ? id : document.importNode(clone(id), true);

  return datamap && data && Object.keys(datamap).forEach(function (key) {
     var i = -1;
     var nodes = fragment.querySelectorAll(datamap[key][0]);
     var node;

     for (; node = nodes[++i];) {
       var prop = datamap[key][1];
       var value = data[key];
       if (prop == 'class') node.classList.add(value);
       else {

         // check for data-* properties
         var dataprop = (dataprop = /data-(.+)/.exec(prop), dataprop && dataprop[1]);

         //simple search and replace
         if (Array.isArray(value)) value = (dataprop
           ? node.dataset[dataprop]
           : node[attr])
              .replace(value[0], value[1]);

         // set data-*
         if (dataprop) node.dataset[dataprop] = value;

         // set prop
         else node[prop] = value;
       }
     }

   }), fragment;
 };

if (!supported) {
  document.addEventListener('DOMContentLoaded', gettemplates(document));
}
